
import useMetaIcons from "~/mixins/useMetaIcons";
import useGtm from "~/mixins/useGtm";

export default {
  mixins: [
    useMetaIcons,
    useGtm,
  ],
};
